import { FinancialAccount } from "@common/types/financialAccount";

export interface EntityGroupItem {
    kind: "entity";
    entityId: number;
}

export interface AccountItem {
    kind: "account";
    accountId: number;
}

export interface SubaccountItem {
    kind: "subaccount";
    subaccountId: string;
}

export type FinancialAccountComboboxItem =
    | EntityGroupItem
    | AccountItem
    | SubaccountItem;

function isEntityGroupItem(
    item: FinancialAccountComboboxItem,
): item is EntityGroupItem {
    return item.kind === "entity";
}

function isAccountItem(
    item: FinancialAccountComboboxItem,
): item is AccountItem {
    return item.kind === "account";
}

export function toItemKey(item: FinancialAccountComboboxItem): string {
    if (isEntityGroupItem(item)) {
        return `entity:${item.entityId}`;
    }
    if (isAccountItem(item)) {
        return `account:${item.accountId}`;
    }
    return `subaccount:${item.subaccountId}`;
}

export function accountMatchesSearch(
    account: FinancialAccount,
    search: string,
): boolean {
    const lower = search.trim().toLowerCase();
    if (!lower) {
        return true;
    }
    if (
        [account.name, account.institutionName, account.accountNumberMask].some(
            (value) => (value ?? "").toLowerCase().includes(lower),
        )
    ) {
        return true;
    }
    return (account.subaccounts ?? []).some(
        (subaccount) =>
            (subaccount.name ?? "").toLowerCase().includes(lower) ||
            (subaccount.accountNumber ?? "").toLowerCase().includes(lower),
    );
}

export function getSubaccountIdsForAccounts(
    accounts: FinancialAccount[],
): string[] {
    return accounts.flatMap((account) =>
        (account.subaccounts ?? []).map((subaccount) => subaccount.id),
    );
}
